var map = {
	"./DkbPage.js": "58vG",
	"./ExpPage.js": "Qndb",
	"./Page.js": "FgoN",
	"./PhonePage.js": "JP+a",
	"./index.js": "8NmS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyiS";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules \.js$
// module id = kyiS
// module chunks = 1